// src/services/user.service.ts
import { createApiClient } from "@/utils/api";
import {
  GetUserRequest,
  ListUserNetworkRequest,
  ListUsersRequest,
  ListUsersResponse,
  UpdateUserRequest,
  UserProfile,
  UserService,
} from "@/gen/api/v1/user_pb";

const client = createApiClient(UserService);

// Tipos para as respostas
type GetProfileResponse = Awaited<ReturnType<typeof client.getMyProfile>>;
type GetUserResponse = Awaited<ReturnType<typeof client.getUser>>;

export const userService = {
  getProfile: (): Promise<GetProfileResponse> => {
    return client.getMyProfile({});
  },

  updateProfile: (request: UpdateUserRequest): Promise<UserProfile> => {
    return client.updateProfile(request);
  },

  listUsers: (request: ListUsersRequest): Promise<ListUsersResponse> => {
    return client.listUsers(request);
  },

  getUserSponsorChain: (
    request: ListUserNetworkRequest,
  ): Promise<ListUsersResponse> => {
    return client.getUserSponsorChain(request);
  },

  getUserSponsoredChain: (
    request: ListUserNetworkRequest,
  ): Promise<ListUsersResponse> => {
    return client.getUserSponsoredChain(request);
  },

  getUser: (request: GetUserRequest): Promise<GetUserResponse> => {
    return client.getUser(request);
  },
};

export type {
  UpdateUserRequest,
  ListUsersRequest,
  ListUsersResponse,
  ListUserNetworkRequest,
  GetUserRequest,
  UserProfile,
};
